module.exports = __webpack_public_path__ + "img/tc.e766297.svg";